import React, { useState, useEffect } from 'react';
import { UloadProps, AuditDetailsObject } from '../interfaces';
import { Alert, Col, Container, Row, Spinner } from 'react-bootstrap';
import { DISPLAY } from '../constants';
import DefaultScreen from '../UtilContainer/DefaultScreen';
import ErrorScreen from '../UtilContainer/ErrorScreen';
import UloadFilterSection from '../UloadFilterSection/UloadFilterSection';
import ExcelDragDrop from '../ExcelDragDrop/ExcelDragDrop';
import styles from './Uload.module.css';
import ActivityLogIcon from '../../images/FinalOutcomeReportImages/Activity Log.png';
import AuditModal from '../AuditModal/AuditModal';
import UloadNotes from '../UloadNotes/UloadNotes';
import { getAuditDetails } from '../apiCalls';

const Uload: React.FC<UloadProps> = (props: UloadProps) => {
  const [displayStatus, setDisplayStatus] = useState<string>(
    props.uloadDisplayStatus
  );

  const [selectedFilter, setFilter] = useState('Select Uload');
  const [uploadError, setUploadError] = useState<string>('');
  const [uploadRecordSize, setUploadRecordSize] = useState<number>();
  const [showUloadNotesView, setShowUloadNotesView] = useState<boolean>(false);
  const [auditSuccess, setAuditSuccess] = useState<boolean>(false);
  const [auditdetails, setAuditDetails] = useState<AuditDetailsObject[]>([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const isSucess =
    displayStatus === DISPLAY.SUCCESS && selectedFilter !== 'Select Uload';
  const isError = displayStatus === DISPLAY.ERROR;

  const handleSuccess = (data: any) => {
    setUploadRecordSize(data.rowsAffected);
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
      setUploadRecordSize(0);
    }, 10000);
  };

  const handleError = (error: string) => {
    setUploadError(error);
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
      setUploadError('');
    }, 10000);
  };

  const displayLogs = async () => {
    setAuditSuccess(true);
    try {
      const response = await getAuditDetails(props.userData[0].GPID);
      if (response) {
        setAuditDetails(Array.isArray(response) ? response : []);
      }
      setAuditSuccess(false);
    } catch (err) {
      console.error('Error while sending the request:', err);
      setAuditSuccess(false);
    }
    setShowUloadNotesView(true);
  };

  return (
    <>
      <Container fluid className='ml-auto mt-2'>
        <Row>
          <Col>
            <h3>BSR ULOAD</h3>
          </Col>
          <Col className={styles.uloadNotesLink}>
            <span className={styles.logOption} onClick={displayLogs}>
              <img
                className={styles.uloadNotesIcon}
                src={ActivityLogIcon}
                alt='Audit Log'
              />
              <span className='ml-2'>Audit Log</span>
            </span>
          </Col>
        </Row>
      </Container>
      <UloadFilterSection
        userData={props.userData}
        setCurrentFilters={setFilter}
      />
      {auditSuccess && (
        <Container className={styles.loadingScreen}>
          <Spinner animation='grow' />
          <p>Loading Audit Data</p>
        </Container>
      )}
      {isSucess && (
        <Container
          fluid
          className='ml-auto mt-2'
          style={{ position: 'relative' }}
        >
          <Row className='mt-4'>
            <Col>
              <ExcelDragDrop
                onSuccess={handleSuccess}
                onError={handleError}
                userGPID={props.userData[0].GPID}
                selectedFilter={selectedFilter}
              />
              {showSuccess && (
                <Alert variant='success' className='mt-3'>
                  {`${uploadRecordSize} record inserted successfully!`}
                </Alert>
              )}
              {showError && (
                <Alert variant='danger' className='mt-3'>
                  {uploadError}
                </Alert>
              )}
            </Col>
            <Col
              style={{
                height: 'calc(80vh - 160px - 0rem)',
                borderLeft: '2px solid grey',
              }}
            >
              <UloadNotes selectedFilter={selectedFilter} />
            </Col>
          </Row>
        </Container>
      )}
      {!isSucess && !auditSuccess && <DefaultScreen />}
      {isError && <ErrorScreen />}
      {
        <AuditModal
          showState={showUloadNotesView}
          setActivityView={() => setShowUloadNotesView(false)}
          auditdetails={auditdetails}
        />
      }
    </>
  );
};

export default Uload;
